export const validateFileExtension = (filename: string): string => {
    const lowercaseFilename = filename.toLowerCase();

    if (!lowercaseFilename.endsWith('.csv')) {
        return 'Por favor, selecciona un archivo CSV o Excel v�lido';
    }
    return '';
}

export const validateFileWeight = (filesize: number): string => {

    const maxSize = 10 * 1024 * 1024; // 10MB en bytes
    if (filesize > maxSize) {
        return 'El archivo es demasiado grande. Tama�o m�ximo: 10MB'

    }
    return '';
}